
export const SENTRY_DSN = "https://0ffd64644ba8d5268ab52297125c8607@o4507653000855552.ingest.de.sentry.io/4507653006032976";
export const SPECIFIED_PARTYKIT_HOST = "staging.frontierxai.com";
export const CLERK_PUBLISHABLE_KEY = "pk_test_ZmFpci1jb3JnaS04MC5jbGVyay5hY2NvdW50cy5kZXYk";
export const POSTHOG_KEY = "phc_8vr2o7Ni6ZMcF52BBn3mnk7hFKBjefsWI73jw3CAhNH";
export const POSTHOG_ENABLED = "true";
export const AUTH_SERVICE_URL = "https://frontierx-auth-staging.netlify.app/";
export const APP_DOWNLOAD_HOST = "download-staging.frontierxai.com";
